import React from 'react'
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv'
import { BckgDiv } from '../whitaijiFrontendLibrary/components/VisDiv'
import { useAuthContext } from "../whitaijiFrontendLibrary/auth/hooks/useAuthContext"
import { _FETCH } from '../utils/patches'
import { useQuery } from "@tanstack/react-query"
import { AuthContext } from '../context/AuthContext'
import T from '../components/Translation'
import { useStateContext } from '../context/StateContext'
import { HiOutlineArrowSmLeft, HiOutlineArrowSmRight} from "react-icons/hi";
import { useNavigate } from 'react-router-dom';
// components
import BlueButton from '../components/BlueButton'
import ConcertMusicPlayer from '../components/ConcertMusicPlayer'
import useMediaQuery from '../hooks/useMediaQuery'
import Divider from '../whitaijiFrontendLibrary/components/Divider'
import { songLyrics } from '../data/songLyrics'
import { SoulbrunchNumbers } from '../components/Graphics'


const Home = () => {
  const navigate = useNavigate();
  const {user} = useAuthContext(AuthContext)
  const {hideTestButtons, language, apiUrl} = useStateContext();
  const screenSizeNotMobile = useMediaQuery("(min-width: 742px)")

/*   const { data: myProjects, isLoading: myProjectsLoading} = useQuery({
    queryKey: ['myProjects'],
    enabled: !!user,
    queryFn: async () => {
      const projects = await _FETCH({
        route: `${apiUrl}/projects/cards`,
        user
      });
      return projects;
    }
  }); */

  const testFunction = () => {
    process.env.NODE_ENV === "development" && console.log("myProjects")
  } 
  //const errorTest = undefined.find((item) => item?._id == "123")

  return (
    <div className="home">
      <BlueButton fn={testFunction} hide={hideTestButtons} text={"Test Button"} />
      <LeftTextRightPicture imageStyle={{width:"80%"}} imageContainerStyle={{alignItems:"flex-end"}} screenChange={1310} imageSource={"/homePictures/mikeProfile.png"}>
        <div style={{display:"flex", alignItems:"center", flexDirection:"column"}}>
          <CatchPhrase    
            motto = {<T str={"refineEmotions"}/>}
            highlightedWords = {<T str={"reMind"}/>}
            mottoEnd = {<T str={"growth"}/>}
            catchPhrase = {<T str={"embraceChange"}/>}
            highlightedCatchPhrase = {<T str={"songAffirmations"}/>}
          />
          <ConcertMusicPlayer
            songs={songLyrics}
            hideScreen={true}
            //secondsOnly={true}
          />
          <CallToActionButtons
            style={{marginTop:"1px", marginBottom:"20px"}}  
            //goldButtonText = {<T str={"moreSongs"}/>}
            blueButtonText = {<T str={"howYouFeel"}/>} 
            blueButtonFn={() => {
              window.scrollTo(0, 0);
              navigate('/tell-me-how-you-feel');
            }}
          />
        </div>
      </LeftTextRightPicture>    
      <div className={"blue-background"}>
       <Quote style={{marginTop:"10px"}} dark author = {"Michael Bianco"}>
{/*           "Take a moment to remember one song that has had a strong emotional impact in your life. <br/>
          recreate the feeling that it sparked inside of you. <br/> 
          How do you feel?" */}
          <T obj = {{
            en: <>
                  Consistent repetition is key to behavioural growth and psychological transformation.
                  <br />
                  Music merged with powerful affirmations can help you exercise mental strength
                  <br />
                  and form new neural pathways faster.
                </>,
            it: <>
                  La ripetizione costante è la chiave per la crescita comportamentale e la trasformazione psicologica.
                  <br />
                  La musica, unita a potenti affermazioni, può aiutarti a rafforzare la mente
                  <br />
                  e a formare nuove connessioni neurali più rapidamente.
                </>
          }} />
        </Quote>
        <CallToActionButtons
            goldButtonText = {<T str={"moreAboutMichael"}/>}
            goldButtonFn = {() => {
              window.scrollTo(0, 0);
              navigate('/about');
            }} 
          />
        <Testimonials slideHeight={300} slideWidth={450} />
      </div>

      <div style={{display:"flex", marginTop:"30px", alignItems:"center", justifyContent:"center"}}>
       <h1><T str={"comingSoon"}/></h1>
      </div>
      <div style={{display:"flex", justifyContent:"center"}}>
        <img 
          src={"/homePictures/bookCover.png"}
          alt="Mike Profile" 
            style={{ 
              maxWidth: `70%`, 
            }} 
        />
      </div>
      <div style={{marginBottom:"30px"}}></div>
      <CardWithBackground>
          <h1 style={{color: goldColour, marginBottom:"20px"}}>
            <T obj = {{en: "Are you a psychologist, a mental health practitioner or a coach?", it: "Sei uno psicoanalista, uno psicologico o un coach?"}}/> 
          </h1>
          <h3>
          <T obj = {{
            en: <>  
            Help your clients with  <span style={{color: goldColour}}><b>reMind</b></span>, by providing them with session summaries, homework plans and songs 
            to listen during the week in between sessions.           
            </>,
            it: <>
            Aiuta i tuoi clienti con  <span style={{color: goldColour}}><b>reMind</b></span>, 
            offrendo loro riassunti delle sessioni, pianificazioni, compiti e canzoni da ascoltare durante la settimana tra le sessioni.
            </>
          }}/>

          </h3>
{/*           <CallToActionButtons
              goldButtonText = {<T str={"joinTheWaitingList"}/>} 
            /> */}
      </CardWithBackground>

      <RightTextLeftPicture screenChange={1070}  title={<T str={"howItWorks"}/>} imageSource={"/homePictures/howCanWeHelp.png"}>
        <div style={{padding: "12px", fontSize: "16px", textAlign:"justify"}}>
          <p>
            <T obj = {{
              en: <>  
                The  <span style={{color: goldColour}}><b>reMind</b></span> songs were created from the content of <b>SoulBrunch</b>, a live streaming program that ran from 2020 to 2022. 
                Through interactive segments, songs and affirmations on personal growth were co-created with a community of tens of thousands. 
                Each song reflects universal struggles and experiences, offering listeners a sense of connection. <br/> <br/>
                The lyrics address difficult topics in the verses, with reframes and positive affirmations in the choruses. 
                By engaging with these songs, you'll find moments of clarity and empowerment as you align with the shared journey of growth.
              </>,
              it: <>
                Le canzoni <span style={{color: goldColour}}><b>reMind</b></span> sono state create ed ispirate dai contenuti di <b>SoulBrunch</b>, un programma in diretta in streaming che è andato in onda dal 2020 al 2022. 
                Attraverso segmenti interattivi, canzoni e affermazioni sulla crescita personale sono state co-create con una comunità di decine di migliaia di persone. 
                Ogni canzone riflette difficoltà ed esperienze universali, offrendo agli ascoltatori un senso di connessione. <br/> <br/>
                I testi affrontano le parti più difficili degli argomenti trattati nei versi, le affermazioni positive nei ritornelli aiutano ad attuare un "reframe" dei problemi. 
                Interagendo con queste canzoni, troverai momenti di chiarezza ed "empowerment" mentre ti allinei con il percorso condiviso di crescita.
              </>
            }}/> 
          </p>
             <GoldTags tagList = {language == "it" ? reMindArgomenti : reMindTopics}/>
        </div>
      </RightTextLeftPicture >
     <SoulbrunchNumbers />  
      <LeftTextRightPicture withModal={true} screenChange={1070} imageSource={language == "it" ? "/homePictures/aiExampleIt.png" : "/homePictures/aiExample.png"}>
          <div style={{ display:"flex", padding:"15px", flexDirection:"column"}}>
            <p style={{fontSize: "16px", textAlign:"justify"}}>
            <T obj = {{
                en: <>  
                  Music connects deeply with our emotions, speeding up personal transformation by pairing  
                  <span style={{color: goldColour}}><b>reMind</b></span> songs with positive change. 
                  Consistent repetition is key to growth, and music makes it easier by creating emotional impact and forming new neural pathways. <br/> <br/> 
                  <span style={{color: goldColour}}><b>reMind</b></span> is designed to help you transform while enjoying the process. 
                  With a short description of how you are feeling, our AI will help you find the right song for your situation and guide you through the process.
                </>,
                it: <>
                  La musica si connette profondamente con le nostre emozioni, accelerando la trasformazione personale abbinando  
                  le canzoni di <span style={{color: goldColour}}><b>reMind</b></span> al cambiamento positivo. 
                  La ripetizione costante è fondamentale per la crescita personale, e la musica rende il processo più semplice creando un impatto emotivo e formando nuovi percorsi neurali. <br/> <br/> 
                  <span style={{color: goldColour}}><b>reMind</b></span> è progettato per aiutarti a trasformarti con processo semplice e piacevole. 
                  Con una breve descrizione di come ti senti, la nostra AI ti aiuterà a trovare la canzone giusta per la tua situazione.
                </>
              }}/>
            </p>
            <CallToActionButtons
              goldButtonText = {<T str={"learnMore"}/>}
              goldButtonFn={() => {
                window.scrollTo(0, 0);
                navigate('/how-it-works');
              }}
/*               blueButtonText = {'More About "What If"'} 
              blueButtonFn={() => {
                window.scrollTo(0, 0);
                navigate('/anxiety-what-if');
              }} */
            />
          </div>
        </LeftTextRightPicture>
    </div>
  )
}

export default Home

export const LeftTextRightPicture = ({children, withModal, style={}, title, imageSource, screenChange = 742, imageStyle = {}, imageContainerStyle = {} }) => {
  const screenSizeNotMobile = useMediaQuery(`(min-width: ${screenChange}px)`)
  const mobileStyle = screenSizeNotMobile ? {} : {
    flexDirection: "column"
  }
  return (
    <div style={{...style}}>

      <div className='home-text-right-pic' style={{...mobileStyle}}>
        <div style={{flexDirection:"column"}} className='left'>
          <VisDiv rules={[title]}>
            <h1 style={{textAlign: 'center', marginTop: '15px', marginBottom: '15px'}}>{title}</h1>
          </VisDiv>
          {children}
        </div>
        <div className='right' style={{...imageContainerStyle}}>
        {withModal ?  <PictureWithModal imageStyle={imageStyle} imageSource={imageSource}/> : 
          <img 
          src={imageSource} 
          style={{ 
            maxWidth: '100%', 
            ...imageStyle,
          }} 
        />}  

        </div>
    </div>
  </div>
  )
}
export const RightTextLeftPicture = ({children, withModal, imageSource, title, imageStyle, imageContainerStyle={}, screenChange = 742 }) => {
  const screenSizeNotMobile = useMediaQuery(`(min-width: ${screenChange}px)`)
  const mobileStyle = screenSizeNotMobile ? {} : {
    flexDirection: "column-reverse"
  }
  return (
    <div>
      <div className='home-text-right-pic' style={{...mobileStyle}}>
        <div style={imageContainerStyle} className='left'>
        {withModal ?  <PictureWithModal imageStyle={imageStyle} imageSource={imageSource}/> : 
          <img 
          src={imageSource} 
          alt="Mike Profile" 
          style={{ 
            maxWidth: '100%', 
            ...imageStyle,
          }} 
        />}  
        </div>
        <div style={{flexDirection:"column"}} className='right'>
          <VisDiv rules={[title]}>
            <h1 style={{textAlign: 'center', marginTop: '15px', marginBottom: '15px'}}>{title}</h1>
          </VisDiv>
          {children}
        </div>
    </div>
  </div>
  )
}

export const BottomTextTopPicture = ({withModal, children, title, imageSource, pictureMaxWidth = 100 }) => {
  return(
      <div style={{padding: "30px"}}>
        <VisDiv rules={[title]}>
          <h1 style={{textAlign: 'center', marginTop: '15px', marginBottom: '15px'}}>{title}</h1>
        </VisDiv>
        <div style={{ fontSize: "26px", padding:"15px"}}>
          <div style={{display:"flex", justifyContent:"center"}}>
          {withModal ?  <PictureWithModal imageSource={imageSource}/> : 
          <img 
          src={imageSource} 
          alt="Mike Profile" 
          style={{ 
            maxWidth: '100%', 
          }} 
        />} 
          </div>
          {children}
        </div>
    </div>
  )
}
export const Quote = ({style={}, children, author, dark, fontSize="30px"}) => {
  const textColour = dark ? {color: goldColour} : {}
  const authorColour = dark ? {color: "white"} : {}
  return (
    <div style={{paddingLeft:"40px", paddingRight:"40px", ...style}} className='flex-center-column text-center'>
      <h2 style={{...textColour, fontSize:fontSize}}>{children}</h2> 
      <p style={{...authorColour,marginTop:"10px", fontSize:"20px"}}>{author}</p>
    </div>

  )
  
}

export const CatchPhrase = ({catchPhrase, highlightedCatchPhrase, motto, highlightedWords, mottoEnd}) => {

  return (
    <div>
      <div>
        <p style={{marginTop:"10px", fontSize:"20px", display:"inline"}}>{motto} </p>
        <p style={{fontSize:"22px", color:goldColour, fontWeight:"bold", display:"inline"}}>{highlightedWords}</p>
        <p style={{marginTop:"10px", fontSize:"20px", display:"inline"}}>{mottoEnd} </p>
      </div>

      <div>
        <h1 style={{fontWeight:"bold", display:"inline"}}>{catchPhrase}</h1>     
        <h1 style={{ marginLeft:"5px", padding: "0px 12px 5px 12px", backgroundColor:goldColour, color:"white", fontSize:"42px", fontWeight:"bold", display:"inline"}}>{highlightedCatchPhrase}</h1>  
      </div>

    </div>

  )
  
}

export const CallToActionButtons = ({style, goldButtonText, blueButtonText, goldButtonFn=() => {}, blueButtonFn=() => {}}) => {
  return (
    <div style={{ display:"flex", marginTop:"20px", alignItems:"center", justifyContent:"center", flexDirection:"row", ...style}}>
      <VisDiv rules={[goldButtonText]}>
        <BlueButton fn = {goldButtonFn} buttonStyle={{fontSize:"20px", padding:"15px"}} color={goldColour} hoverColor={lighterBlueColour} text={goldButtonText} />
      </VisDiv>
      <VisDiv rules={[blueButtonText]}>
        <BlueButton fn = {blueButtonFn} buttonStyle={{fontSize:"20px", padding:"15px"}} text={blueButtonText} />
      </VisDiv>
    </div>
    )
}

const CardWithBackground = ({children, cardHeight="600"}) => {
  const screenSizeNotMobile = useMediaQuery("(min-width: 742px)")
  return(
  <BckgDiv style={{
    display:"flex", 
    marginBottom:"50px", 
    flexDirection:"column", 
    justifyContent:"center", 
    alignItems:"center", 
    width:"100%",
    padding: screenSizeNotMobile ? "0" : "0 20px"
  }} imgSource="/homePictures/psychologistBackground.png">
  <div style={{
    display:"flex", 
    borderRadius:"20px",   
    boxShadow: "-6px 6px 10px rgba(0, 0, 0, 0.5)",  
    opacity:"0.95",  
    padding:"25px", 
    marginTop:"50px", 
    marginBottom:"-50px",  
    flexDirection:"column", 
    color:"white", 
    justifyContent:"center", 
    textAlign:"center", 
    backgroundColor:"#343C5F", 
    alignItems:"center", 
    minHeight:`${cardHeight}px`,
    width: screenSizeNotMobile ? "400px" : "100%",
    maxWidth: "400px"
  }}>
    {children}
  </div>
</BckgDiv>
)
}

export const Testimonials = ({ slideHeight = 200, slidesToShow = 2, slideWidth = 300 }) => {
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const testimonialImages = [
    "/homePictures/testimonials/Screenshot 2021-06-30 at 14.07.11.png",
    "/homePictures/testimonials/Screenshot 2021-06-30 at 14.07.18.png",
    "/homePictures/testimonials/Screenshot 2021-06-30 at 14.07.30.png",
    "/homePictures/testimonials/Screenshot 2021-07-07 at 13.59.00.png",
    "/homePictures/testimonials/Screenshot 2021-07-07 at 13.59.08.png",
    "/homePictures/testimonials/Screenshot 2021-07-07 at 13.59.18.png",
    "/homePictures/testimonials/Screenshot 2021-07-07 at 14.06.00.png",
    "/homePictures/testimonials/Screenshot 2021-07-07 at 14.15.13.png",
    "/homePictures/testimonials/Screenshot 2021-07-07 at 14.15.25.png",
    "/homePictures/testimonials/Screenshot 2021-07-07 at 14.15.31.png",
    "/homePictures/testimonials/Screenshot 2021-07-07 at 14.15.50.png",
    "/homePictures/testimonials/Screenshot 2021-07-07 at 14.16.46.png",
    "/homePictures/testimonials/Screenshot 2021-07-09 at 13.43.14.png",
    "/homePictures/testimonials/Screenshot 2021-07-09 at 13.43.57.png",
    "/homePictures/testimonials/Screenshot 2021-07-09 at 13.57.14.png",
    "/homePictures/testimonials/Screenshot 2021-07-26 at 13.22.43.png",
    "/homePictures/testimonials/Screenshot 2021-07-26 at 13.22.49.png",
    "/homePictures/testimonials/Screenshot 2021-08-11 at 13.36.28.png",
    "/homePictures/testimonials/Screenshot 2021-08-17 at 14.36.14.png",
    "/homePictures/testimonials/Screenshot 2021-08-18 at 14.01.28.png",
    "/homePictures/testimonials/Screenshot 2021-08-18 at 14.10.07.png",
    "/homePictures/testimonials/Screenshot 2021-08-18 at 14.10.54.png",
    "/homePictures/testimonials/Screenshot 2021-08-19 at 14.23.54.png",
    "/homePictures/testimonials/Screenshot 2021-08-20 at 13.07.47.png",
    "/homePictures/testimonials/Screenshot 2021-08-20 at 13.39.43.png",
    "/homePictures/testimonials/Screenshot 2021-08-20 at 13.57.42.png",
    "/homePictures/testimonials/Screenshot 2021-08-20 at 14.02.00.png",
    "/homePictures/testimonials/Screenshot 2021-08-20 at 14.03.12.png",
    "/homePictures/testimonials/Screenshot 2021-08-30 at 14.26.22.png",
    "/homePictures/testimonials/Screenshot 2021-08-30 at 14.26.26.png",
    "/homePictures/testimonials/Screenshot 2021-08-30 at 14.26.37.png",
    "/homePictures/testimonials/Screenshot 2021-08-30 at 14.44.50.png",
    "/homePictures/testimonials/Screenshot 2021-08-30 at 14.48.07.png",
    "/homePictures/testimonials/Screenshot 2021-08-30 at 14.48.34.png",
    "/homePictures/testimonials/Screenshot 2021-08-30 at 14.59.53.png",
    "/homePictures/testimonials/Screenshot 2021-08-30 at 14.59.57.png",
    "/homePictures/testimonials/Screenshot 2021-08-30 at 15.02.40.png",
    "/homePictures/testimonials/Screenshot 2021-08-30 at 15.02.47.png",
    "/homePictures/testimonials/Screenshot 2021-08-30 at 15.19.35.png",
    "/homePictures/testimonials/Screenshot 2021-08-30 at 15.19.57.png",
    "/homePictures/testimonials/Screenshot 2021-09-01 at 15.22.37.png",
    "/homePictures/testimonials/Screenshot 2021-09-01 at 15.35.46.png",
    "/homePictures/testimonials/Screenshot 2021-09-01 at 15.47.01.png",
    "/homePictures/testimonials/Screenshot 2021-09-01 at 15.47.29.png",
    "/homePictures/testimonials/Screenshot 2021-09-02 at 15.09.29.png",
    "/homePictures/testimonials/Screenshot 2021-09-02 at 15.11.58.png",
    "/homePictures/testimonials/Screenshot 2021-09-03 at 13.48.35.png",
    "/homePictures/testimonials/Screenshot 2021-09-20 at 14.43.06.png",
    "/homePictures/testimonials/Screenshot 2021-11-24 at 16.09.03.png",
    "/homePictures/testimonials/Screenshot 2021-11-24 at 16.09.13.png"
  ]

  React.useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [currentIndex]);

  const handlePrev = () => {
    setCurrentIndex(prev => 
      prev === 0 ? testimonialImages.length - slidesToShow : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex(prev => 
      prev === testimonialImages.length - slidesToShow ? 0 : prev + 1
    );
  };

  return (
    <div className="testimonials-container">
      <h1 style={{textAlign: 'center', color: 'white', marginBottom: '30px'}}><T str={"testimonials"}/></h1>
      <div className="testimonials-wrapper">
        <div 
          className="testimonials-track"
          style={{
            transform: `translateX(-${currentIndex * (slideWidth + 20)}px)` // slideWidth + 20px gap
          }}
        >
          {testimonialImages?.map((image, index) => (
            <div 
              key={index} 
              className={`testimonial-slide`}
              style={{ 
                height: `${slideHeight}px`,
                overflow: 'hidden',
                flex: `0 0 ${slideWidth}px`,
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                backgroundColor: '#897a6f',
                opacity: index >= currentIndex && index < currentIndex + slidesToShow ? 1 : 0.5,
                transition: 'opacity 0.5s ease-in-out, transform 0.5s ease-in-out',
                transform: index >= currentIndex && index < currentIndex + slidesToShow ? 'scale(1)' : 'scale(0.9)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <img 
                src={image} 
                alt={`Testimonial ${index + 1}`}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                  borderRadius: '8px',
                  padding: '10px'
                }}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="testimonials-nav">
        <button className="nav-button" onClick={handlePrev}><HiOutlineArrowSmLeft size={30}/></button>
        <button className="nav-button" onClick={handleNext}><HiOutlineArrowSmRight size={30}/></button>
      </div>
    </div>
  )
}


export const PictureWithModal = ({imageSource, imageStyle,}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <div style={{display: "flex", justifyContent: "center", marginTop: "30px", marginBottom: "40px"}}>
        <img 
          src={imageSource} 
          onClick={openModal}
          style={{
            maxWidth: "100%",
            height: "auto",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            cursor: "pointer",
            ...imageStyle,
          }}
          alt="Clickable content"
        />
      </div>

      {isModalOpen && (
        <div 
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            cursor: "pointer"
          }}
          onClick={closeModal}
        >
          <img 
            src={imageSource}
            style={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              objectFit: "contain",
              borderRadius: "10px"
            }}
            alt="Full screen content"
          />
        </div>
      )}
    </>
  );
}

export const GoldTags = ({tagList}) => {
  return (
    <div style={{display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "20px"}}>
    {tagList?.map((topic, index) => (
      <div 
        key={index}
        style={{
          backgroundColor: goldColour,
          color: "white",
          padding: "8px 16px",
          borderRadius: "20px",
          fontSize: "14px",
          fontWeight: "bold"
        }}
      >
        {topic}
      </div>
    ))}
  </div>
  )
}

export const Tag = ({text, color="#fcba03", style={}, onClick, textColor="white"}) => {
  return (
    <div 
      onClick={onClick}
      style={{
        backgroundColor: color,
        color: textColor,
        padding: "8px 16px",
        borderRadius: "20px",
        fontSize: "14px",
        fontWeight: "bold",
        display: "inline-block",
        textAlign: "center",
        ...style
      }}
    >
      {text}
    </div>
  )
}
export const goldColour = "#fcba03"
export const blueColour = "#343C5F"
export const lighterBlueColour = "#495587"

export const reMindTopics = [
  "Inner Child",
  "Fear of failure",
  "Perfectionism",
  "Effective communication",
  "Anger",
  "Action VS Reaction",
  "Pain",
  "Grief",
  "Standing up for yourself",
  "Managing boundaries",
  "Fear of the unknown",
  "Anxiety",
  "Manifestation",
  "Self Worth",
  "Identity",
  "Acceptance"
]
export const reMindArgomenti = [ "Bambino interiore",
  "Paura del fallimento",
  "Perfezionismo",
  "Comunicazione efficace",
  "Rabbia",
  "Azione VS Reazione",
  "Dolore",
  "Lutto",
  "Farsi valere",
  "Gestione dei confini",
  "Paura dell'ignoto",
  "Ansia",
  "Manifestazione",
  "Autostima",
  "Identità",
  "Accettazione"
  ]
